<div role="separator" class="flex min-w-0 items-center py-2">
    <mat-divider aria-hidden="true" class="w-4 shrink-0" />
    @if (ariaLabel()) {
        <span class="sr-only">{{ ariaLabel() }}</span>
    }
    <apcam-tooltip-custom
        class="min-w-0 max-w-full px-2"
        display="block"
        [customMatTooltip]="tooltip() ?? ''"
        [customMatTooltipDisabled]="!tooltip() || !tooltipEnabled()"
        (mouseenter)="updateTooltipState()">
        <span
            #label
            class="group-separator-label block min-w-0 truncate text-center"
            [attr.aria-hidden]="ariaLabel() ? 'true' : null">
            <ng-content />
        </span>
    </apcam-tooltip-custom>
    <mat-divider aria-hidden="true" class="min-w-4 grow shrink-0" />
</div>
